import {UserActionTypes} from './global.types'
const INITIAL_STATE = {
    user_id:0,
    flight_token:null,
    passenger_data:[],
    airport_list:[],
    flights_list:{
        status:false,
        TraceId:null,
        Origin:null,
        Destination:null,
        Results:[]
    },
    calender_fare:{
        status:false,
        TraceId:null,
        Origin:null,
        Destination:null,
        searchResults:[]
    },
    search_data : {
        TokenId:null,
        adultcount:1,
        childcount:0,
        infantcount:0,
        direct_flight:0,
        journeyType:1,
        flight_from:'',
        flight_to:'',
        flight_from_name:'',
        flight_to_name:'',
        departure_date:new Date(),
        arrival_date:new Date(),
        FlightCabinClass:1,
        Segments:[]
    },
    search_filters:{
        status:false,
        TraceId:null,
        Origin:null,
        Destination:null,
        Results:[],
        Results2:[]
    },
    fare_rule:{
        status:false,
        FareRules:{}
    },
    fare_quote:{
        status:false,
        IsPriceChanged:false,
        Results:{}
    },
    showBottomSticky:0,
    sticky_data:{},
    sticky_data2:{},
    airlines:[],
    request_passenger:{
        adultcount:0,
        childcount:0,
        infantcount:0
    },
    passenger_ids:[]
}

const globalReducer = (state = INITIAL_STATE,action) => {
    switch (action.type) {

        case UserActionTypes.SET_PASSENGER_IDS:
            return {
                ...state,
                passenger_ids:action.passenger_ids
            }

        case UserActionTypes.SET_FLIGHT_TOKEN:
            return {
                ...state,
                flight_token:action.flight_token
            }

        case UserActionTypes.SET_AIRPORT_LIST:
            return {
                ...state,
                airport_list:action.airport_list
            }

        case UserActionTypes.SET_SEARCH_FLIGHTS:
            return {
                ...state,
                flights_list:action.flights_list
            }

        case UserActionTypes.SET_CALENDER_FARE:
            return {
                ...state,
                calender_fare:action.calender_fare
            }

        case UserActionTypes.SET_SEARCH_DATA:
            return {
                ...state,
                search_data:action.search_data
            }

        case UserActionTypes.SET_FILTER_DATA:
            return {
                ...state,
                search_filters:action.search_filters
            }

        case UserActionTypes.SET_FARE_RULE:
            return {
                ...state,
                fare_rule:action.fare_rule
            }

        case UserActionTypes.SET_FARE_QUOTE:
            return {
                ...state,
                fare_quote:action.fare_quote
            }

        case UserActionTypes.SET_BOTTOM_STICKY:
            return {
                ...state,
                showBottomSticky:action.showBottomSticky
            }

        case UserActionTypes.SET_BOTTOM_STICKY_DATA:
            return {
                ...state,
                sticky_data:action.sticky_data
            }

        case UserActionTypes.SET_BOTTOM_STICKY_DATA2:
            return {
                ...state,
                sticky_data2:action.sticky_data2
            }

        case UserActionTypes.SET_USER_ID:
            return {
                ...state,
                user_id:action.user_id
        }

        case UserActionTypes.SET_AIRLINES:
            return {
                ...state,
                airlines:action.airlines
        }

        case UserActionTypes.SET_REQUEST_PASSENGER:
            return {
                ...state,
                request_passenger:action.request_passenger
        }

        case UserActionTypes.SET_PASSENGER_DATA:
            return {
                ...state,
                passenger_data:action.passenger_data
            }
    
        default:
            return state;
    }
}

export default globalReducer;